import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';

const propTypes = {
  text: PropTypes.string,
  height: PropTypes.string,
  showOrLineBreak: PropTypes.bool,
  background: PropTypes.string,
  textColor: PropTypes.string,
  highlightBackground: PropTypes.string,
  highlightTextColor: PropTypes.string,
  onDrop: PropTypes.func,
  style: PropTypes.object,
  readOnlyMode: PropTypes.bool
};

const defaultProps = {
  text: 'Drag a profile photo here',
  height: '400px',
  showOrLineBreak: true,
  background: '#000',
  textColor: '#507090',
  highlightBackground: '#507090',
  highlightTextColor: '#507090',
  style: {},
  readOnlyMode: false,
  accept: '',
  multiple: ''
};

const FileUploader = (props) => {
  const [isFileOver, setIsFileOver] = useState(false);
  const {
    text,
    height,
    showOrLineBreak,
    background,
    highlightBackground,
    textColor,
    highlightTextColor,
    style
  } = props;

  const styles = StyleSheet.create({
    fileDropContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      fontWeight: 'bold',
      flexFlow: 'column nowrap',
      height,
      color: isFileOver ? highlightTextColor : textColor,
      background: `${isFileOver ? highlightBackground : background}`,
      border: isFileOver ? `1px solid ${textColor}` : ''
    },
    fileInputContainer: {
      position: 'relative'
    },
    fileInputWrapper: {
      position: 'relative',
      cursor: 'pointer'
    },
    fileInput: {
      position: 'absolute',
      right: '0px',
      top: '0px',
      fontFamily: 'Arial',
      fontSize: '118px',
      margin: '0px',
      padding: '0px',
      cursor: 'pointer',
      opacity: '0',
      height: '100%',
      width: '100%'
    }
  });

  const handleDragEnter = () => {
    if (!props.readOnlyMode) {
      setIsFileOver(true);
    }
  };

  const handleDragLeave = () => {
    if (!props.readOnlyMode) {
      setIsFileOver(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault(e);
    if(!props.readOnlyMode) {
      setIsFileOver(true);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!props.readOnlyMode) {
      setIsFileOver(false);
  
      if (e.dataTransfer.items) {
        for (let i = 0; i < e.dataTransfer.items.length; i++) {
          if (e.dataTransfer.items[i].kind === 'file') {
            const img = e.dataTransfer.items[i].getAsFile();
            console.log('img', img);
            console.log('typeof img', typeof img);
            props.onDrop(img);
          }
        }
      }
    }
  };

  return (
    <div
      className={css(styles.fileDropContainer)}
      style={{
        ...style,
        cursor: props.readOnlyMode ? 'no-drop' : ''
      }}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {!isFileOver &&
        <div
          style={{
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            flexGrow: '1'
          }}>
          {/* Title */}
          {props.title &&
            <div style={{ color: props.titleColor }}>
              {props.title}
            </div>
          }
          {/* File drop message */}
          {/* <div className={css(styles.fileInputContainer)}>
            {text}
          </div> */}
          {/* OR line break */}
          {showOrLineBreak && <div>OR</div>}
          {/* File input container */}
          <div className={css(styles.fileInputWrapper)}>
            {/* <div>Select a File</div> */}
            <div className={css(styles.fileInputContainer)}>
              {text}
            </div>
            {!props.readOnlyMode &&
              <input
                type="file"
                accept={props.accept}
                multiple={props.multiple}
                ref={props.parentRef}
                onChange={props.onChange}
                className={css(styles.fileInput)}
              />
            }
          </div>
        </div>
      }
      {/* Post icon */}
      {!isFileOver && props.postIcon && <div>{props.postIcon}</div>}
      {/* File Over - File drop message */}
      {isFileOver &&
        <div
          style={{
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: '1',
            color: textColor,
            cursor: props.readOnlyMode ? 'no-drop' : ''
          }}
        >
          Drop File
        </div>
      }
    </div>
  );
};

FileUploader.propTypes = propTypes;
FileUploader.defaultProps = defaultProps;
export { FileUploader };
